const LOCATION_PLACEHOLDER_LABELS = new Set(['Detectar localização', 'Perto de você'])

export function isPlaceholderLocationLabel(value: string): boolean {
  return LOCATION_PLACEHOLDER_LABELS.has(value.trim())
}
